import * as React from "react";
import type { SVGProps } from "react";
const SvgPassport = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4 1h16c.55 0 1 .45 1 1v20c0 .55-.45 1-1 1H4c-.55 0-1-.45-1-1V2c0-.55.45-1 1-1Zm1 2v18h14V3H5Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M18 12c0 3.31-2.69 6-6 6s-6-2.69-6-6 2.69-6 6-6 6 2.69 6 6Zm-9.266 2.307A4.013 4.013 0 0 0 11 15.873v-1.161a10.93 10.93 0 0 1-2.266-.405Zm4.266.405v1.161a4.013 4.013 0 0 0 2.266-1.566c-.674.201-1.442.342-2.266.405Zm2.266-5.02A4.013 4.013 0 0 0 13 8.128v1.161c.824.063 1.592.204 2.266.405ZM13 11.296c.907.083 1.855.264 2.663.705-.808.44-1.756.622-2.663.705v-1.41Zm-2 0v1.41c-.907-.083-1.855-.264-2.663-.705.808-.44 1.756-.622 2.663-.705Zm0-2.007c-.824.063-1.592.204-2.266.405A4.013 4.013 0 0 1 11 8.127v1.161Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgPassport;
